module.exports = __webpack_public_path__ + "static/media/identitoBlueLogo.4328abb8.svg";